/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.Tags = class Tags {
  _defaultOptions() {
    return {
      delimiters: [
        9,  // tab
        13, // return
        188, // comma
        32 // space
      ],
      trimTags: true,
      maxTags: 6,
      showCloseButtons: true,
      autoTagOnBlur: true,
      validateTag(value) { return undefined; },
      tagsChanged(count) { return undefined; },
      validTagEntered() { return undefined; },
      validTagNotEntered() { return undefined; },
      containerClass: "tag-input",
      tagClass: "tag",
      minInputWidth: 30
    };
  }

  constructor(input, opts) {
    this._tagCloseClick = this._tagCloseClick.bind(this);
    this._tagInputContents = this._tagInputContents.bind(this);
    this._tagKeyDown = this._tagKeyDown.bind(this);
    this._tagInput = this._tagInput.bind(this);
    this._updatePlaceholder = this._updatePlaceholder.bind(this);
    this._resizeInput = this._resizeInput.bind(this);
    this.input = input;
    if (opts == null) { opts = {}; }
    this.opts = _.merge(this._defaultOptions(), opts);
    this._setup();
    this._bindEvents();
    this._resizeInput();
  }

  tagCount() {
    return this._tags().length;
  }

  clear() {
    this._tags().remove();
    this.tagInput.val("");
    this._updateInput();
    this._updatePlaceholder();
    this._resizeInput();
    return this.opts.tagsChanged(this.tagCount());
  }

  addTag(value) {
    if (this.tagCount() >= this.opts.maxTags) {
      this._showTooltip(`Maximum of ${this.opts.maxTags} allowed`);
      return false;
    }

    if (this.opts.trimTags) { value = value.trim(); }

    if (this.opts.validateTag != null) {
      const result = this.opts.validateTag(value);
      if (result) {
        this._showTooltip(result);
        return false;
      }
    }

    const $tag = $("<span />").
      addClass(this.opts.tagClass).
      data("value", value).
      text(value);

    if (this.opts.showCloseButtons) {
      const $close = $("<a />").
        html("&times;");
      $tag.append($close);
    }

    $tag.insertBefore(this.tagInput);

    this.opts.tagsChanged(this.tagCount());
    this._updateInput();
    return true;
  }

  _bindEvents() {
    this.tagInput.keydown(this._tagKeyDown);
    this.tagInput.on("keyup", this._tagInput);
    this.el.click(e => {
      return this.tagInput.focus();
    });

    if (this.opts.autoTagOnBlur) {
      this.tagInput.on("blur", this._tagInputContents);
    }

    return this.el.on("click", `span.${this.opts.tagClass} a`, this._tagCloseClick);
  }

  _tagCloseClick(e) {
    const $tag = $(e.currentTarget).parent();
    $tag.remove();
    this._updatePlaceholder();
    this._resizeInput();
    this.tagInput.focus();
    this.opts.tagsChanged(this.tagCount());

    e.preventDefault();
    return false;
  }

  _tagInputContents() {
    if (!this._contentEntered()) { return true; }

    if (this.addTag(this.tagInput.val())) {
      this.tagInput.val("");
      this._updatePlaceholder();
      this._resizeInput();
      return true;
    } else {
      return false;
    }
  }

  _tagKeyDown(e) {
    const delimiterHit = _.some(this.opts.delimiters, d => e.keyCode === d);

    if (!this._contentEntered() && (e.keyCode === 9)) { // tab hit
      // allow to propogate
      return;
    }

    if (!this._contentEntered() && (e.keyCode === 8)) { // backspace hit
      const $tag = this.tagInput.prev();
      if ($tag.is(`span.${this.opts.tagClass}`)) {
        $tag.remove();
        this._updatePlaceholder();
        this._resizeInput();
        this.opts.tagsChanged(this.tagCount());
      }
    }

    if (delimiterHit) {
      this._tagInputContents();
      e.preventDefault();
      return false;
    }

    return this._hideTooltip();
  }

  _tagInput(e) {
    this._updatePlaceholder();
    this._resizeInput();

    if (this.opts.validateTag == null) {
      return this.opts.validTagEntered();
    }

    if (!this.opts.validateTag(this.tagInput.val())) {
      return this.opts.validTagEntered();
    } else {
      return this.opts.validTagNotEntered();
    }
  }


  _updatePlaceholder() {
    if (this._contentEntered() || (this._tags().length > 0)) {
      return this.tagInput.attr("placeholder", "");
    } else {
      return this.tagInput.attr("placeholder", this.tagInput.data("placeholder"));
    }
  }

  _resizeInput() {
    const paddingLeft = parseInt(this._getStyle(this.tagInput, "padding-left"));
    const paddingRight = parseInt(this._getStyle(this.tagInput, "padding-right"));

    const width = !this._contentEntered() ?
      this._measureText(this.tagInput.attr("placeholder"))
    :
      this._measureText(this.tagInput.val());

    return this.tagInput.css({
      width: width + paddingLeft + paddingRight + 20
    });
  }

  _updateInput() {
    const result = _.map(this._tags(), tag => $(tag).data("value"));

    return this.input.val(result.join(","));
  }

  _tags() {
    if (this.el) {
      return this.el.find(`span.${this.opts.tagClass}`);
    } else {
      return [];
    }
  }

  _measureText(string) {
    const $el = $("<div />").
      text(string).
      css({
        position: "absolute",
        whiteSpace: "nowrap",
        visibility: "hidden",
        float: "left",
        font: this._getStyle(this.tagInput, "font"),
        letterSpacing: this._getStyle(this.tagInput, "letter-spacing")
      }).
      appendTo($("body"));

    const width = $el.outerWidth();

    $el.remove();

    return width;
  }

  _getStyle($el, key) {
    const el = $el[0];

    if (el.currentStyle != null) { return el.currentStyle[key]; }

    if ((document.defaultView != null) && (document.defaultView.getComputedStyle != null)) {
      return document.defaultView.getComputedStyle(el, "")[key];
    }

    return el.style[key];
  }

  _contentEntered() {
    return $.trim(this.tagInput.val()).length > 0;
  }

  _showTooltip(text) {
    this.tagInput.tooltipster("content", text);
    this.tagInput.tooltipster("enable");
    return this.tagInput.tooltipster("show");
  }

  _hideTooltip() {
    this.tagInput.tooltipster("disable");
    return this.tagInput.tooltipster("hide", () => {
      return this.tagInput.tooltipster("content", "");
    });
  }

  _setup() {
    this.tagInput = this.input.clone();
    this.tagInput.
      attr("name", "").
      attr("id", "").
      attr("data-placeholder", this.tagInput.attr("placeholder")).
      attr("placeholder", "");

    this._updatePlaceholder();

    this.input.attr("type", "hidden");

    this.el = $("<div />");
    this.el.
      addClass(this.opts.containerClass).
      insertAfter(this.input).
      append(this.input).
      append(this.tagInput);

    this.tagInput.tooltipster({
      position: "bottom",
      content: "hello"
    });

    return this.tagInput.tooltipster("disable");
  }
};
